// extracted by mini-css-extract-plugin
export default {"links":"links__req++"};